(function($) {
  const stickyElement = document.querySelector('.container-fluid-mobile .col-6:first-child');
  const stickyTop = stickyElement.offsetTop;
  
  window.addEventListener('scroll', () => {
    const isStuck = window.scrollY - 50 >= stickyTop;
    const isStuckTop = window.scrollY >= stickyTop;
  
    if (isStuck) {
      stickyElement.classList.add('is-stuck');
    } else {
      stickyElement.classList.remove('is-stuck');
    }

    if (!isStuckTop) {
      // console.log(window.scrollY,stickyTop);
      $('.tt-mobile-product-slider')[0].slick.refresh();
    }
  });

})(jQuery);